'use strict';

/**
 * The identity function.
 *
 * @param a The value to return.
 * @returns The value `a` unchanged.
 * @example
 *
 * import { id } from 'fkit'
 * id(1) // 1
 */
function id(a) {
  return a;
}

module.exports = id;
